import UIScaleManager from "@baseUI/controllers/UIScaleManager";
import SlotEventManager from "@baseUI/controllers/SlotEventManager";
import Signals from "@baseUI/controllers/UISignals";
import UIFacade from "@baseUI/UIFacade";
import UIApplicationLoader from "@baseUI/component/loader/UIApplicationLoader";
import UIConfig from "@baseUI/config/UIConfig";
import TextFactory from "@localisation/TextFactory";
import UIModelView from "@baseUI/model/UIModelView";
import Facade from "@/Facade";

export default class UIController {

    constructor(uiModel, uiView) {

        this.uiModel = uiModel
        this.uiView = uiView
        this.init()
    }

    init() {

        this.uiModelView = new UIModelView()
        this.scaleMananger = new UIScaleManager(this.uiModelView)
        this.eventMananger = new SlotEventManager(this.uiModel, this.uiView)

        UIFacade.model = this.uiModel

        //Signals.uiLoadAssets.add(this.onLoadAssets, this)  ???
        Signals.startUI.add(this.onStart, this)
        this.onLoadAssets()
    }

    onLoadAssets() {
        this.appLoader = new UIApplicationLoader()
        const parameters = {fonts: UIConfig.fonts, fontsPath: UIConfig.fontsPath, assetsPath: UIConfig.assetsPath}
        this.appLoader.startLoad(parameters).then(()=>{
            this.onMainAssetsLoadingComplete()
        })
    }

    onMainAssetsLoadingComplete = () => {
        const styles = this.appLoader.getLoaderResources('uiPixiTextStyles')
        const strings = this.appLoader.getLoaderResources('uiLocalizedStrings')
        const infoStrings = this.appLoader.getLoaderResources('uiInfoStrings')
       // UIConfig.pattern = this.appLoader.getLoaderResources('uiPattern')
        UIFacade.styles = styles
        UIFacade.Names = this.appLoader.getLoaderResources('Names')
        UIFacade.Paytable = this.appLoader.getLoaderResources('Paytable')
        UIFacade.LayoutsConfig = this.appLoader.getLoaderResources('LayoutsConfig')
        UIFacade.InfoChapters = this.appLoader.getLoaderResources('InfoChapters')
        UIFacade.textFactory = new TextFactory(styles, {
            ...strings,
            ...infoStrings,
        }, UIConfig.locale, false)

        document.dispatchEvent(new Event("UIIsLoaded"))
    }


    onStart(container, menuContainer) {
        this.uiView.init(container, menuContainer, this.uiModelView)
        document.addEventListener("show", this.onShow.bind(this))
        document.addEventListener("showUI", this.onShow.bind(this))
        document.addEventListener("hide", this.onHide.bind(this))

        UIFacade.textFactory.changeLocaleAndRefresh(UIFacade.model.initData.locale)
        UIFacade.model.lobbyURL = Facade.urlParams.lobbyUrl || Facade.model.lobbyURL;
        this.uiView.updateText()
        document.dispatchEvent(new CustomEvent("UIIsReady"))

        Signals.setState.dispatch('fullscreen', UIFacade.model.initData.fullscreen)
        Signals.setState.dispatch('quickSpin', UIFacade.model.initData.isQuickSpin)
        Signals.setState.dispatch('spaceToSpin', UIFacade.model.initData.spaceToSpin.enable)
        Signals.setState.dispatch('whenEnteringFreeSpins', UIFacade.model.initData.whenEnteringFreeSpins)
    }

    onShow(){
        this.uiView.show()
    }

    onHide(){
        this.uiView.hide()
    }
}
